// extracted by mini-css-extract-plugin
export default {"generic":"XC3wym"};